import React from "react";
import { BuildingFacilityTagModel } from "src/api/building/commonfacility-types";

type Props = {
  tag: BuildingFacilityTagModel;
  className?: string;
  onClear?: (item: any) => void;
};

const TagChip = ({ tag, className, onClear }: Props) => {
  const handleClear = (item: BuildingFacilityTagModel) => {
    onClear?.(item);
  };

  return (
    <div className="flex-center facility-tag-color">
      <span className={` ${className ? className : ""} font13`}>{tag.name}</span>
      {onClear && (
        <button type="button" className="base-chip-with-btn__clear-black " onClick={() => handleClear(tag)}></button>
        // <button type="button" className="base-chip-with-btn__clear-black " onClick={() => handleClear(tag)}>
        //   X
        // </button>
      )}
    </div>
  );
};

export default TagChip;
